/* Bootstrap imports */
import Bootstrap from 'bootstrap-sass/assets/javascripts/bootstrap';

/* Utilities imports */
import { ScrollTo } from './Utilities/ScrollTo';
import ResizeFunction from './Utilities/Resize';
import DistributeHeight from './Utilities/DistributeHeight'
/*import {Fancybox} from './Utilities/Fancybox';*/

/* Theme imports */
/* eg. import tooltip from './Theme/Tooltip'; */
import {SearchBox} from './Theme/SearchBox';
import { FunctionGuide } from './Theme/FunctionGuide'
import { Usertemplate } from "./Theme/Usertemplate"

/* Module imports */
import { Slider } from './Modules/Slider'

let functionGuide = new FunctionGuide()
functionGuide.setHeight()
functionGuide.initEventHandlers()
functionGuide.historyPopstate()

document.querySelectorAll('[data-role="text-slider"]').forEach((element) => {
    element.slider = new Slider(element)
})

/* Renders */
window.scrollto = new ScrollTo();
let resizeFunction = new ResizeFunction(functionGuide);
new SearchBox();
new Usertemplate()

resizeFunction.resize()

const distributeHeight = new DistributeHeight
$('.panel-collapse').on('hidden.bs.collapse', function () {
    distributeHeight.setHeights()
})

$('.panel-collapse').on('shown.bs.collapse', function () {
    distributeHeight.setHeights()
})



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Index.js